import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom/cjs/react-router-dom";
import KeywordsSlider from "./KeywordsSlider";
import ChooseLanguage from "../../modals/ChooseLanguage";
import { useDispatch, useSelector } from "react-redux";
import useFirebase from "../../../../../useFirebase";
import { isEmpty } from "lodash";
import useLangTranslation from "../../../../customHooks/languageProvider";
import SetRulesDisableSupervison from "../SetRulesDisableSupervison";
import useSetRules from "../useSetRules";
import CommonStatus from "../../Common/CommonStatus";
import useDeviceStatus from "../../../../customHooks/deviceStatusProvider";
import { setShowMessage } from "../../../AxiosRtk/successMessage";
import DeleteChildInfo from "../../modals/DeleteChildInfo";
import { getMyIPAddress } from "../../../AxiosRtk/Miscellaneous";
import { deleteKidAccount } from "../../../AxiosRtk/AddNewChild";
import { setSelectedKidId } from "../../../AxiosRtk/DashBoard";
import Select from "react-select";
import KidImage from "../../../../shared/KidImage/KidImage";
import { useDashboardDataProvider } from "../../../../customHooks/dashboardDataProvider";

const EditKeywords = () => {
  const dispatch = useDispatch();
  const [deviceOptions, setDeviceOptions] = useState([]);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [languageSelected, setLanguageSelected] = useState(null);
  const [selectedKeywords, setSelectedKeywords] = useState([]);
  const [webMonitoringData, setWebMonitoringData] = useState(null);
  const [allSafeSearchKeywords, setAllSafeSearchKeywords] = useState([]);
  const [ownKeywords, setOwnKeywords] = useState("");
  const [kid, setKid] = useState(null);
  const [device, setDevice] = useState(null);
  const { getLangTranslation } = useLangTranslation();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [reason, setReason] = useState({ value: "", error: "" });
  const { handleDeviceSelection } = useDashboardDataProvider();

  const [deviceStatus, setDeviceStatus] = useState("");
  const { getDeviceStatusData } = useDeviceStatus(
    deviceStatus,
    setDeviceStatus
  );

  const { postCollectionData, getCollectionData, createCollectionData } =
    useFirebase();

  const { AdminSetRuleLanguageData, setRulesData } = useSelector(
    ({ setRules }) => setRules
  );

  const { kidList, selectedKidId, kidDevicesList, selectedDeviceData } =
    useSelector(({ dashboard }) => dashboard);

  const { handleTimeSupervision } = useSetRules();

  useEffect(() => {
    if (kidList && selectedKidId) {
      const kid = kidList?.find(
        (item) => parseInt(item?.ID) === parseInt(selectedKidId)
      );
      setKid(kid);
    }
  }, [kidList, selectedKidId, selectedDeviceData]);


  const history = useHistory();
  const handleGoBack = useCallback(() => {
    history.goBack();
  });

  const [isRadioChecked, setIsRadioChecked] = useState(1);

  const handleCardClick = (checked) => {
    setIsRadioChecked(checked);
  };

  const [showModal, setShowModal] = useState(false);
  const openModal = () => {
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
  };

  function callFireStore(payload) {
    if (isEmpty(setRulesData)) {
      createCollectionData(selectedDeviceData?.ID, { webmonitoring: payload });
    } else {
      postCollectionData(selectedDeviceData?.ID, { webmonitoring: payload });
    }
    getCollectionData(selectedDeviceData?.ID);
    setTimeout(() => {
      dispatch(
        setShowMessage({
          showMessage: true,
          defaultMessage: "Data saved successfully",
          message: "DATA_SAVED",
        })
      );
    }, 1000);
  }

  function getSortedData(data) {
    return data.sort((a, b) => {
      let x = a.value.toLowerCase();
      let y = b.value.toLowerCase();

      if (x < y) return -1;
      if (x > y) return 1;
      return 0;
    });
  }

  useEffect(() => {
    getCollectionData("AdminSetRuleData", "Languages");
  }, []);

  useEffect(() => {
    if (selectedDeviceData?.ID) {
      getDeviceStatusData(selectedDeviceData?.ID);
    }
  }, [selectedDeviceData?.ID]);

  useEffect(() => {
    if (isRadioChecked === 2) {
      const youtubeKeywordData = { ...webMonitoringData?.youtubeSearchKeyword };
      let ownKeywords = [];
      if (youtubeKeywordData?.usingKedoKeywords) {
        ownKeywords = [...youtubeKeywordData?.userOldKeyWords];
      } else {
        ownKeywords = [...youtubeKeywordData?.keyWords];
      }

      setSelectedKeywords(
        ownKeywords?.map((item) => {
          return {
            id: Math.floor(Math.random() * Math.pow(10, 7)),
            value: item,
          };
        })
      );
    }
  }, [isRadioChecked]);

  useEffect(() => {
    if (selectedDeviceData?.ID) {
      getCollectionData(selectedDeviceData?.ID);
    }
  }, [selectedDeviceData?.ID]);

  useEffect(() => {
    if (setRulesData) {
      setWebMonitoringData(setRulesData?.webmonitoring);
      const youtubeSearchKeywordObj = {
        ...setRulesData?.webmonitoring?.youtubeSearchKeyword,
      };
      const tempLangArr = [...(AdminSetRuleLanguageData?.languages ?? [])];
      const getSelectedLang = tempLangArr?.find(
        (item) =>
          parseInt(item?.id) === parseInt(youtubeSearchKeywordObj?.languageId)
      );
      setLanguageSelected(getSelectedLang);

      let settedKeywords = youtubeSearchKeywordObj?.keyWords ?? [];
      settedKeywords = settedKeywords?.map((item) => {
        return {
          id: Math.floor(Math.random() * Math.pow(10, 7)),
          value: item,
        };
      });
      setSelectedKeywords(settedKeywords);
    }
  }, [setRulesData]);

  useEffect(() => {
    if (languageSelected) {
      const keywordsArr = languageSelected
        ? languageSelected?.safeSearchKeywords?.split(";")?.map((item) => {
          return {
            id: Math.floor(Math.random() * Math.pow(10, 7)),
            value: item,
          };
        })
        : [];
      const keywordArrSorted = getSortedData(keywordsArr);
      setAllSafeSearchKeywords(keywordArrSorted);
    }
  }, [languageSelected]);

  function handleSave() {
    if (!selectedKidId) {
      return;
    } else {
      const tempLangArr = [...AdminSetRuleLanguageData?.languages];
      const langBlock = tempLangArr?.find(
        (item) => parseInt(item?.id) === parseInt(selectedItemId)
      );
      setLanguageSelected(langBlock);
      closeModal();
    }
  }

  function handleKeywordRemove(item, isOwnKeyword = false) {
    const tempArr = [...selectedKeywords];

    const itemToRemove = tempArr?.find(
      (keyword) => parseInt(keyword?.id) === parseInt(item?.id)
    );
    const itemIndex = tempArr?.findIndex(
      (keyword) => parseInt(keyword?.id) === parseInt(item?.id)
    );
    tempArr?.splice(itemIndex, 1);
    const tempArrSortedData = getSortedData(tempArr);
    setSelectedKeywords(tempArrSortedData);

    if (!isOwnKeyword) {
      allSafeSearchKeywords?.push(itemToRemove);
      const safeSearchData = getSortedData(allSafeSearchKeywords);
      setAllSafeSearchKeywords(safeSearchData);
    }
  }

  function handleApplyAll() {
    const youtubeSearchKeyword = {
      ...webMonitoringData?.youtubeSearchKeyword,
    };

    if (isRadioChecked === 1) {
      if (isEmpty(allSafeSearchKeywords)) {
        return;
      }

      youtubeSearchKeyword["usingKedoKeywords"] = true;
      youtubeSearchKeyword["isRTL"] = languageSelected?.isRTL;
      youtubeSearchKeyword["keyWords"] = allSafeSearchKeywords?.map(
        (item) => item?.value
      );
      youtubeSearchKeyword["languageId"] = languageSelected?.id;
      youtubeSearchKeyword["userOldKeyWords"] = [
        ...webMonitoringData?.youtubeSearchKeyword?.keyWords,
      ];
    } else {
      if (isEmpty(ownKeywords)) {
        return;
      }

      setOwnKeywords("");
      youtubeSearchKeyword["usingKedoKeywords"] = false;
      youtubeSearchKeyword["isRTL"] = languageSelected?.isRTL;
      youtubeSearchKeyword["keyWords"] = ownKeywords
        ?.trim()
        ?.split(",")
        ?.map((item) => item);
      youtubeSearchKeyword["languageId"] = languageSelected?.id;
    }


    const collectionPayload = {
      ...webMonitoringData,
      youtubeSearchKeyword,
    };

    callFireStore(collectionPayload);
  }

  function handleClearAll() {
    const youtubeSearchKeyword = {
      ...webMonitoringData?.youtubeSearchKeyword,
    };

    if (isRadioChecked === 1) {
      youtubeSearchKeyword["usingKedoKeywords"] = true;
      youtubeSearchKeyword["isRTL"] = languageSelected?.isRTL;
      youtubeSearchKeyword["userOldKeyWords"] =
        webMonitoringData?.youtubeSearchKeyword?.keyWords ?? [];
      youtubeSearchKeyword["keyWords"] = [];
      youtubeSearchKeyword["languageId"] = languageSelected?.id;
    } else {
      youtubeSearchKeyword["usingKedoKeywords"] = false;
      youtubeSearchKeyword["isRTL"] = 0;
      youtubeSearchKeyword["keyWords"] = [];
      youtubeSearchKeyword["languageId"] = 0;
    }

    const collectionPayload = {
      ...webMonitoringData,
      youtubeSearchKeyword,
    };
    callFireStore(collectionPayload);
  }

  useEffect(() => {
    if (setRulesData) {
      setWebMonitoringData(setRulesData?.webmonitoring);
      const youtubeSearchKeywordObj = {
        ...setRulesData?.webmonitoring?.youtubeSearchKeyword,
      };
      const tempLangArr = [...(AdminSetRuleLanguageData?.languages ?? [])];

      const getSelectedLang = tempLangArr?.find(
        (item) =>
          parseInt(item?.id) === parseInt(youtubeSearchKeywordObj?.languageId)
      );
      setLanguageSelected(getSelectedLang);

      let settedKeywords = youtubeSearchKeywordObj?.keyWords ?? [];
      settedKeywords = settedKeywords?.map((item) => {
        return {
          id: Math.floor(Math.random() * Math.pow(10, 7)),
          value: item,
        };
      });
      setSelectedKeywords(settedKeywords);
    }
  }, [setRulesData]);

  useEffect(() => {
    if (languageSelected) {
      const keywordsArr = languageSelected
        ? languageSelected?.safeSearchKeywords?.split(";")?.map((item) => {
          return {
            id: Math.floor(Math.random() * Math.pow(10, 7)),
            value: item,
          };
        })
        : [];
      const keywordArrSorted = getSortedData(keywordsArr);
      setAllSafeSearchKeywords(keywordArrSorted);
    }
  }, [languageSelected]);

  function handleSave() {
    if (!selectedKidId) {
      return;
    } else {
      const tempLangArr = [...AdminSetRuleLanguageData?.languages];
      const langBlock = tempLangArr?.find(
        (item) => parseInt(item?.id) === parseInt(selectedItemId)
      );
      setLanguageSelected(langBlock);
      closeModal();
    }
  }

  function closeDeleteModal() {
    setShowDeleteModal(false);
  }

  const getPublicIp0 = useCallback(async () => {
    try {
      const { data: ipAddData } = await getMyIPAddress();
      return ipAddData?.ip;
    } catch (error) {
      console.log("Ip0", error);
    }
  }, []);

  async function handleContinue() {
    if (!reason?.value) {
      setReason({
        ...reason,
        error: "Please enter reason",
      });
      return;
    }

    setLoader(true);

    const ip = await getPublicIp0();

    const deleteProfilePayload = {
      kidId: selectedKidId,
      kidName: kid?.childName,
      ipAddress: ip,
      reason: reason?.value,
    };

    deleteKidAccount(deleteProfilePayload)
      .then((res) => {
        closeModal();
        // setShowDeletedModal(true);
      })
      .catch((err) => {
        setReason({
          ...reason,
          error: err?.response?.data?.message + ". Redirecting to dashboard.",
        });
        setTimeout(() => {
          window.location.href = "/dashboard";
        }, 2500);
        console.log(
          "child delete catch error ==>>",
          err?.response?.data?.message
        );
      })
      .finally(() => {
        setLoader(false);
        dispatch(setSelectedKidId(kidList[0]?.ID));
      });
  }

  useEffect(() => {
    setDeviceOptions(
      kidDevicesList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [kidDevicesList]);

  return (
    <>
      <div className="card mb-6">
        <div className="card-body">
          <div className="inline-list-wrap align-items-center separator space-24">
            <div className="list-item">
              <div className="list-content">
                <div className="d-inline-flex align-items-center lh-1">
                  <Link
                    to="/"
                    className="text-blue-900 fs-5"
                    onClick={handleGoBack}
                  >
                    <i className="icon-arrow-left" />
                  </Link>
                  <h3 className="text-blue-900 mb-0">
                    {" "}
                    {getLangTranslation(
                      "WEB_MONITORING_SAFE_SEARCH_YOUTUBE_LINK_TO_KEYWORDS",
                      "Edit your keywords"
                    )}
                  </h3>
                </div>
              </div>
            </div>
            <div className="list-item">
              {/* <span className="icon-wrap icon-rounded me-2 p-0 overflow-hidden ratio ratio-1x1 border-0">
                <img src={ChildPic} alt="image" />
              </span> */}
              <KidImage imageUrl={kid?.image} gender={kid?.gender} />
              <div className="list-content">
                <h5 className="text-blue-900 mb-0">{kid?.childName}</h5>
                <CommonStatus status={deviceStatus} />
              </div>
            </div>
            <div className="list-item col-12 col-md-3">
              <div className="select-with-icon">
                <span className="icon-wrap icon-blue pt-cursor border-0">
                  <i className="icon-mobile fs-5" />
                </span>
                {/* <select
                  className="form-select text-dark single-select-text"
                  value={selectedDeviceData?.ID || ""}
                  onChange={(e) => setDevice(e.target.value)}
                >
                  <option value="">Select</option>
                  {kidDevicesList?.map((item, index) => {
                    return (
                      <option value={item?.ID} key={index}>
                        {item?.Name}
                      </option>
                    );
                  })}
                </select>*/}
                <Select
                  className="custom-select "
                  classNamePrefix="custom-select"
                  placeholder="Select Device"
                  options={deviceOptions}
                  value={
                    deviceOptions?.find((item) => item?.value == selectedDeviceData?.ID) || ""
                  }
                  onChange={handleDeviceSelection}
                  isSearchable={false}
                />
              </div>
            </div>
            {/* <span className="form-check form-switch ms-auto align-self-center mb-0">
                            <label className="form-check-label" htmlFor="deviceTime">Disable Supervision</label>
                            <input className="form-check-input" id='deviceTime' type="checkbox" role="switch" defaultChecked />
                        </span>
                        <span className="icon-wrap pt-cursor">
                            <i className="icon-setting"></i>
                        </span> */}
            {device && (
              <>
                <SetRulesDisableSupervison
                  enableSupervision={setRulesData?.enableSupervision}
                  handleTimeSupervision={handleTimeSupervision}
                  deviceSelected={device}
                />
                <span className="icon-wrap pt-cursor">
                  {/* <i className="icon-setting"></i> */}
                  <div className="dropdown">
                    <i
                      className="icon-setting  pt-cursor"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    />
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li
                        className="px-6 pt-cursor fw-semibold d-flex justify-content-between align-items-center gap-1"
                        onClick={() =>
                          history.push("/set-rules/manage-notifications")
                        }
                      >
                        {getLangTranslation(
                          "MANAGE_NOTIFICATIONS",
                          "Manage notifications"
                        )} <i className="icon-arrow-right" />
                      </li>
                      <li
                        className="px-6 pt-cursor d-flex fw-semibold justify-content-between align-items-center gap-1"
                        onClick={() => history.push("/set-rules/copy-settings")}
                      >
                        {getLangTranslation("COPY_SETTINGS", "Copy settings")} <i className="icon-arrow-right" />
                      </li>
                      <li
                        className="px-6 pt-cursor d-flex fw-semibold justify-content-between align-items-center gap-1"
                        onClick={() =>
                          history.push("/set-rules/default-settings")
                        }
                      >
                        {getLangTranslation(
                          "SETRULE_LOAD_DEFAULT_SETTINGS",
                          "Load default settings"
                        )} <i className="icon-arrow-right" />
                      </li>
                      <li
                        className="px-6 pt-cursor d-flex fw-semibold justify-content-between align-items-center gap-1 text-danger"
                        onClick={() => setShowModal(true)}
                      >
                        {getLangTranslation("SET_RULES_DELETE_CHILD_PROFILE", "Delete child's profile")?.replace('child', kid?.childName)}{" "}
                        <i className="icon-arrow-right" />
                      </li>
                    </ul>
                  </div>
                </span>
              </>
            )}
            <DeleteChildInfo
              showModal={showDeleteModal}
              closeModal={closeDeleteModal}
              handleContinue={handleContinue}
              loader={loader}
              reason={reason}
              setReason={setReason}
              getLangTranslation={getLangTranslation}
            />
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <h5 className="mb-6">
            {getLangTranslation(
              "DO_YOU_WANT_TO_USE_KIDO_PROTECT_KEYWORDS_CREATE_OWN_KEYWORDS",
              "Do you want to use the Kido Protect keywords list or create your own keywords"
            )}
          </h5>
          <div className="mb-6">
            <div className="form-check form-check-inline me-9">
              <input
                className="form-check-input"
                type="radio"
                checked={isRadioChecked === 1}
                onChange={() => {
                  handleCardClick(1);
                }}
                id="keywordOne"
              />
              <label
                className="form-check-label d-flex flex-column"
                htmlFor="keywordOne"
              >
                <p className="text-small text-blue-900 fw-semibold mb-0">
                  {getLangTranslation(
                    "YOUTUBE_SEARCH_KEYWORD_USE_KIDO_PROTECT_KEYWORD_LIST",
                    "Use Kido Protect keywords list"
                  )}
                </p>
                <span className="text-extra-small">
                  {getLangTranslation(
                    "YOUTUBE_SEARCH_KEYWORD_YOU_WILL_USE_OUR_WON_KEYWORD_LIST",
                    "You will use our own keywords list"
                  )}
                </span>
              </label>
            </div>
            <div className="form-check form-check-inline me-9">
              <input
                className="form-check-input"
                type="radio"
                checked={isRadioChecked === 2}
                onChange={() => {
                  handleCardClick(2);
                }}
                id="keywordTwo"
              />
              <label
                className="form-check-label d-flex flex-column"
                htmlFor="keywordTwo"
              >
                <p className="text-small text-blue-900 fw-semibold mb-0">
                  {getLangTranslation(
                    "YOUTUBE_SEARCH_KEYWORD_USE_YOUR_OWN_KEYWORDS",
                    "Use your own keywords"
                  )}
                </p>
                {/* <span className="text-extra-small">
                  Lorem ipsum dolor sit amet consectetur.
                </span> */}
              </label>
            </div>
          </div>
          <div className={` ${isRadioChecked === 1 ? "d-block" : "d-none"}`}>
            <p className="text-small text-dark mb-3">
              {getLangTranslation("SELECT_A_LANG", "Select a language")}:
            </p>
            <div className="d-flex flex-wrap flex-md-nowrap gap-3 mb-6">
              <div
                className="d-flex flex-fill align-items-center border p-3 rounded-1 gap-2 pt-cursor"
                onClick={openModal}
              >
                {/* <img src="https://flagsapi.com/AR/flat/32.png" alt="flag" /> */}
                <h6 className="mb-0 text-blue-900">
                  {languageSelected?.language}
                </h6>
                <i className="icon-arrow-right ms-auto fs-5 text-blue-800" />
              </div>
              <button className="btn btn-primary" onClick={handleApplyAll}>
                <span className="btn-upper-case text-nowrap">
                  {getLangTranslation("APPLY_ALL", "Apply all")}
                </span>
              </button>
              <button
                className="btn btn-outline-primary"
                onClick={handleClearAll}
              >
                <span className="btn-upper-case text-nowrap">
                  {getLangTranslation("CLEAR_ALL", "Clear all")}
                </span>
              </button>
            </div>

            <p className="text-small text-uppercase mb-6">
              {getLangTranslation(
                "LIST_MAIN_KEYWORD_FOR_ENGLISH",
                "List of main keywords for English"
              )}
            </p>
            <KeywordsSlider
              languageSelected={allSafeSearchKeywords}
            // handleKeywordSelect={handleKeywordSelect}
            />
          </div>
          <div className={` ${isRadioChecked === 2 ? "d-block" : "d-none"}`}>
            <p className="text-small text-dark mb-3">
              {getLangTranslation(
                "KEYSTROKE_MONITORING_ADD_KEYWORDS",
                "Add keywords that needs to be flagged"
              )}
              :
            </p>
            <div className="d-flex flex-wrap flex-md-nowrap gap-3 mb-6">
              <input
                className="form-control"
                type="text"
                placeholder="Enter keywords to be flagged separated by a coma"
                value={ownKeywords}
                onChange={(e) => setOwnKeywords(e.target.value)}
              />
              <button className="btn btn-primary" onClick={handleApplyAll}>
                <span className="btn-upper-case">
                  {getLangTranslation("APPLY", "Apply")}
                </span>
              </button>
              <button
                className="btn btn-outline-primary"
                onClick={handleClearAll}
              >
                <span className="btn-upper-case text-nowrap">
                  {getLangTranslation("CLEAR_ALL", "Clear all")}
                </span>
              </button>
            </div>
            {!webMonitoringData?.youtubeSearchKeyword?.usingKedoKeywords && (
              <div className="d-inline-flex flex-wrap gap-3 mb-6">
                {selectedKeywords?.map((item) => {
                  return (
                    <div className="custom-tag" key={item?.id}>
                      {item?.value}
                      <i
                        className="icon-cancel ms-1 pt-cursor"
                        onClick={() => handleKeywordRemove(item, "OWN_KEYWORD")}
                      />
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
      <ChooseLanguage
        showModal={showModal}
        closeModal={closeModal}
        AdminSetRuleLanguageData={AdminSetRuleLanguageData}
        selectedItemId={selectedItemId}
        setSelectedItemId={setSelectedItemId}
        handleSave={handleSave}
      />
    </>
  );
};

export default EditKeywords;
